var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"info-modal","centered":"","ok-only":"","header-bg-variant":"info","title":"Info"}},[_c('p',{staticClass:"my-4"},[_c('span',{staticStyle:{"white-space":"pre"}},[_vm._v(_vm._s(_vm.content))])])])}
var staticRenderFns = []

export { render, staticRenderFns }